import { initializeApp } from 'firebase'
import 'firebase/firestore'

const fireapp = initializeApp({
    apiKey: "AIzaSyBxwRwOVZ96Z5vJ7bUhSHFpq_lBgL-CHa4",
    authDomain: "eglise-fraternit-1531593127480.firebaseapp.com",
    databaseURL: "https://eglise-fraternit-1531593127480.firebaseio.com",
    projectId: "eglise-fraternit-1531593127480",
    storageBucket: "eglise-fraternit-1531593127480.appspot.com",
    messagingSenderId: "992169767369"
  });
  
const firestore = fireapp.firestore()

export default firestore;